export function validateFileSize(file: File, maxSizeInKb: number): boolean {
  const fileSizeInKb = file.size / 1024;

  return fileSizeInKb < maxSizeInKb;
}
